import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, i = 0, base = 0.1, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.06em] ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "105%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, ease: EASE, delay: base + i * 0.12 }}
    >
      {children}
    </motion.span>
  </span>
);

export const Arrow = ({ className = "", delay = 0.6 }) => (
  <svg viewBox="0 0 1200 90" fill="none" className={className} aria-hidden="true" preserveAspectRatio="none">
    <motion.path
      d="M10 30 C 350 70, 800 72, 1170 22"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinecap="round"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 1.2, ease: EASE, delay }}
    />
    <motion.path
      d="M1100 10 L1180 22 L1135 78"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinecap="round"
      strokeLinejoin="round"
      initial={{ pathLength: 0, opacity: 0 }}
      animate={{ pathLength: 1, opacity: 1 }}
      transition={{ duration: 0.4, ease: EASE, delay: delay + 1.05 }}
    />
  </svg>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-cond text-sm sm:text-base uppercase tracking-[0.22em] text-dano-red ${className}`}>{children}</p>
);

export const ComingSoon = ({ className = "", testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-2 rounded-full bg-dano-red px-3 py-1 font-cond text-xs sm:text-sm uppercase tracking-[0.18em] text-dano-cream ${className}`}>
    <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-dano-cream" />
    Coming soon
  </span>
);
